// extracted by mini-css-extract-plugin
var _1 = "SidebarSectionsModal-module__actionContainer--uHI1G";
var _2 = "SidebarSectionsModal-module__active--XFNdy";
var _3 = "SidebarSectionsModal-module__addItemContainer--HXp3f";
var _4 = "SidebarSectionsModal-module__animateUploadProgressBarWidth--h_73B";
var _5 = "SidebarSectionsModal-module__animatedBackground--TL3pp";
var _6 = "SidebarSectionsModal-module__body--_Zx3D";
var _7 = "SidebarSectionsModal-module__buttons--HHdFL";
var _8 = "SidebarSectionsModal-module__container--KLuN0";
var _9 = "SidebarSectionsModal-module__controls--Xn74_";
var _a = "SidebarSectionsModal-module__createSectionButton--rfVLE";
var _b = "SidebarSectionsModal-module__createSectionButtonContainer--nsYlo";
var _c = "SidebarSectionsModal-module__emptyStateMessage--p2aBa";
var _d = "SidebarSectionsModal-module__footer--vxk5j";
var _e = "SidebarSectionsModal-module__footerAction--Z_vL9";
var _f = "SidebarSectionsModal-module__header--yt_rN";
var _10 = "SidebarSectionsModal-module__headerAction--vFD8_";
var _11 = "SidebarSectionsModal-module__infoIconContainer--LMAWH";
var _12 = "SidebarSectionsModal-module__innerContainer--exwsd";
var _13 = "SidebarSectionsModal-module__nameField--aGlJi";
var _14 = "SidebarSectionsModal-module__overflowMenuButton--GMZv4";
var _15 = "SidebarSectionsModal-module__saveButton--uNjb1";
var _16 = "SidebarSectionsModal-module__scrollablePane--TyeIe";
var _17 = "SidebarSectionsModal-module__sectionTypeSelect--m34Xr";
var _18 = "SidebarSectionsModal-module__text--Yq1Bp";
var _19 = "SidebarSectionsModal-module__titleContainer--NH45G";
export { _1 as "actionContainer", _2 as "active", _3 as "addItemContainer", _4 as "animateUploadProgressBarWidth", _5 as "animatedBackground", _6 as "body", _7 as "buttons", _8 as "container", _9 as "controls", _a as "createSectionButton", _b as "createSectionButtonContainer", _c as "emptyStateMessage", _d as "footer", _e as "footerAction", _f as "header", _10 as "headerAction", _11 as "infoIconContainer", _12 as "innerContainer", _13 as "nameField", _14 as "overflowMenuButton", _15 as "saveButton", _16 as "scrollablePane", _17 as "sectionTypeSelect", _18 as "text", _19 as "titleContainer" }
